import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { Link } from "react-router-dom";

const Impressum = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-4 max-w-4xl">
          <Breadcrumbs items={[{ label: "Impressum" }]} />
          <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-8">
            Impressum
          </h1>

          <div className="space-y-8 text-foreground">
            <section>
              <h2 className="text-2xl font-semibold mb-4">Herausgeber der Website und für den Inhalt verantwortlich</h2>
              <div className="text-muted-foreground leading-relaxed space-y-2">
                <p className="text-foreground font-semibold">EAP® Produktions- und Patentverwertungs-GmbH</p>
                <p>Geschäftsführer: Ing. Dr. med. dent. Mario Kern M.Sc. M.Sc.</p>
                <p>Lorettostraße 26 | 2. und 3. Stock | 6060 Hall in Tirol | Austria</p>
                <p>FB-Gericht Innsbruck, Firmenbuchnummer: 483289w | UID: ATU72852709</p>
                <p>
                  <a href="https://eap-abutments.com" className="text-primary hover:underline">
                    eap-abutments.com
                  </a>
                </p>
                <p className="mt-4">
                  EAP® Abutment ist ein Produkt der EAP® Produktions- und Patentverwertungs-GmbH.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Haftungsausschluss</h2>
              <div className="text-muted-foreground leading-relaxed space-y-4">
                <p>
                  Die Inhalte dieser Website inklusive aller angebotenen Daten sind urheberrechtlich geschützt. 
                  Die Nutzung oder Verbreitung der angebotenen Daten zu privaten oder kommerziellen Zwecken ist nicht gestattet. 
                  Für eine anderweitige Nutzung bedarf es der vorherigen schriftlichen Zustimmung des Urhebers. Alle Rechte vorbehalten.
                </p>
                <p>
                  Sämtliche Inhalte auf dieser Website wurden sorgfältig geprüft. Es kann trotz größter Sorgfalt jedoch 
                  keine Garantie für Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernommen werden. 
                  Eine Haftung für die Inhalte kann daher nicht übernommen werden. 
                  Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
                </p>
                <p>
                  Die Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben veröffentlichten Kontaktdaten 
                  wie Postanschriften, Telefon- und Faxnummern sowie E-Mail-Adressen durch Dritte zur Übersendung von 
                  nicht ausdrücklich angeforderten Informationen ist nicht gestattet. Rechtliche Schritte gegen die 
                  Versender von sogenannten Spam-Mails bei Verstößen gegen dieses Verbot sind ausdrücklich vorbehalten.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Anmerkung</h2>
              <p className="text-muted-foreground leading-relaxed">
                Genderbezogene Formulierung: Im Interesse einer besseren Lesbarkeit wird nicht ausdrücklich in 
                geschlechtsspezifischen Personenbezeichnungen differenziert. Die gewählte männliche Form schließt 
                eine adäquate weibliche und diverse Form gleichberechtigt ein.
              </p>
            </section>

            <div className="pt-8 border-t border-border">
              <p className="text-sm text-muted-foreground mb-3">
                Stand: August 2026 (Version 2.0) – ersetzt die Fassung Mai 2024 (archiviert)
              </p>
              <p className="text-sm text-muted-foreground">
                <Link to="/datenschutz" className="text-primary hover:underline mr-4">Datenschutzerklärung</Link>
                <Link to="/agb" className="text-primary hover:underline">Allgemeine Geschäftsbedingungen (AGB)</Link>
              </p>
            </div>

          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Impressum;
